/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'male': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(5 5)" _stroke="#000" stroke-width=".9"><path pid="0" d="M21.542 21.542c-.001-1.53-.951-2.898-2.384-3.433l-4.61-1.549a.458.458 0 00-.525.177 3.667 3.667 0 01-6.05 0 .458.458 0 00-.524-.176L2.842 18.11a3.667 3.667 0 00-2.384 3.433"/><path pid="1" d="M15.958 17.034a5.45 5.45 0 01-9.916 0"/><path pid="2" d="M14.998 7.092l-.311-1.558C11.02 5.534 11.02 3.7 11.02 3.7h-.077s0 1.833-3.666 1.833l-.31 1.558"/><path pid="3" d="M9.625 11.953c.342.306.787.47 1.245.459h.26c.458.01.903-.153 1.245-.459"/><path pid="4" d="M10.083 8.287a.996.996 0 00-.916-.459.998.998 0 00-.917.459"/><path pid="5" d="M13.75 8.287a.996.996 0 00-.917-.459.998.998 0 00-.916.459"/><path pid="6" d="M10.982 15.163c1.276 0 4.125-1.578 4.534-4.002a.917.917 0 01.527-.684c.991-.45 1.239-2.248.439-2.648.458-2.737.458-7.333-5.5-7.333-5.959 0-5.959 4.596-5.5 7.333-.8.4-.55 2.2.439 2.648a.917.917 0 01.526.684c.406 2.424 3.26 4.002 4.535 4.002z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/male.js